import microApp, { getActiveApps } from "@micro-zoe/micro-app"
import store from "@/store"
import router from "@/router"
import hostMap, { MICRO_APPS, sysBelongConfig } from "@/micro/config"
import { _bus } from "@/utils/index"
import { apiAddLog } from "@/api/user"
var isPathLog = ""
// 通知子应用跳转方法
export function microAppRouter(route) {
  // eslint-disable-next-line prefer-const
  let { name, hash } = route
  if (hash.indexOf("#") > -1) {
    hash = hash.split("#")[1]
  }
  // 获取url匹配关系，找到当前跳转页面的路由信息（包括菜单id等）
  const routeUrlNoQuery = route.fullPath.substring(0, route.fullPath.indexOf("?") > -1 ? route.fullPath.indexOf("?") : route.fullPath.length)
  let getMatchRouter = {}
  try {
    const oneDimensionalMenu = store.state.user.oneDimensionalMenu
    // 先判断是否有type为2是页面
    oneDimensionalMenu.forEach(item => {
      if (item.type === 2) {
        if (item.sysBelong + "#" + item.url === routeUrlNoQuery) {
          getMatchRouter = item
        }
      }
    })
    // 如果没数据 再获取type为1的
    if (!getMatchRouter.id) {
      oneDimensionalMenu.forEach(item => {
        if (item.sysBelong + "#" + item.url === routeUrlNoQuery) {
          getMatchRouter = item
        }
      })
    }
  } catch (e) {
    console.log(e)
  }

  // 存储路由信息上报 写在这里有几率存在上报会有重复上报的问题
  isPathLog = getMatchRouter

  // 发送数据给子应用 my-app，setData第二个参数只接受对象类型
  microApp.forceSetData(name, { type: "router", data: hash, matchRouterInfo: { ...getMatchRouter } })
  // 发送数据调整当前侧边栏状态
  microAppForceSetGlobalData({ type: "sidebarOpened", data: store.state.app.sidebar.opened })
}

// 全局通知方法
export function microAppSetGlobalData(info) {
  const { type, data } = info
  microApp.setGlobalData({ type, data })
}
// 强制通知，防止之前缓存数据不再通知
export function microAppForceSetGlobalData(info) {
  const { type, data } = info
  microApp.forceSetGlobalData({ type, data })
}

// 单个应用通知方法
export function microAppSetData(name, info) {
  const { type, data } = info
  // 强制通知，防止之前缓存数据，不再通知
  microApp.forceSetData(name, { type, data })
}

let logReportTimer = null

// 监听子应用消息方法
export function addSonAppsDataListener(appName) {
  microApp.addDataListener(appName, info => {
    console.log(`%c基座接收到消息为:`, "color: red")
    console.log(info)

    const { type, data } = info

    switch (type) {
      // 子应用跳转自应用页面
      case "router":
        console.log("我router开始接受子应用消息")
        console.log(info)

        // eslint-disable-next-line no-case-declarations
        const newData = convertRoute(data)

        // 如果是2级页面，才进行push跳转
        if (info.data.query.backToOriginPagePath && newData.name) {
          router.push({ path: newData.fullPath })
        }

        // 刷新页面，获取tags
        store.dispatch("tagsView/addView", newData)

        store.state.tagsView.visitedViews.forEach(item => {
          if (item.fullPath.split("?")[0] === router.history.current.fullPath.split("?")[0]) {
            const findItem = store.state.user.oneDimensionalMenu.find(it => it.name === item.title && it.type == 2)
            if (findItem) {
              // 清除之前的定时器，确保只执行最后一次
              clearTimeout(logReportTimer)
              // 设置新的定时器，延迟执行日志上报
              logReportTimer = setTimeout(() => {
                if (findItem?.id) {
                  const { id, name } = findItem
                  apiAddLog({ opMenuId: id, operateType: "VIEW_PAGE", deviceType: 1, logType: 1, content: "查看了页面:" + name })
                }
              }, 300) // 300ms 是防抖延迟时间，可根据需求调整
            }
          }
        })

        break
      // 子应用跳转跨应用页面
      case "k_router":
        // eslint-disable-next-line no-case-declarations
        const knewData = convertRoute(data)
        if (knewData.query) {
          knewData.fullPath = knewData.fullPath + "?"
          for (const knewDataKey in knewData.query) {
            knewData.fullPath = knewData.fullPath + `${knewDataKey}=${knewData.query[knewDataKey]}&`
          }
        }
        router.push({ path: encodeURI(knewData.fullPath) })
        store.dispatch("tagsView/changeNowClickActionType", "jump")
        store.dispatch("tagsView/addView", knewData)
        break
      // 子应用通知主应用，wct朋友圈点赞，右上角通知栏
      case "notice":
        store.dispatch("comment/requestCommentNotifyList", data)
        break
      // 子应用通知主应用，改变标签名称
      case "changTitle":
        store.dispatch("tagsView/changeTitle", data)
        break

      // 通知打开导入导出窗口
      case "openExportModule":
        _bus.$emit("openExportDodule", true)
        setTimeout(() => {
          _bus.$emit("changeActiveType", data)
        }, 300)
        break

      // 获取最新的导入导出进行中的数量
      case "getExportImportCount":
        store.dispatch("user/getCurrentTask", {})
        break

      default:
        console.log("来自子应用my-app的数据", data)
        break
    }
  })
}
// 路由转换
const convertRoute = data => {
  // eslint-disable-next-line no-case-declarations
  let firstPath = data.fullPath.split("/")[1]
  // 权限中心比较特殊，没有作为一个中心上传git，而是和主数据合在一起，所以需要单独判断下
  if (firstPath === "authorityCenter") {
    firstPath = "masterData"
  }
  // eslint-disable-next-line no-case-declarations
  const newData = {
    fullPath: "/" + firstPath + "#" + data.fullPath,
    name: data.name,
    path: data.path,
    query: data.query,
    meta: data.meta || {}
  }
  // 跳转的页面与本地菜单匹配，找到对应菜单，进行数据添加
  const hasData = store.state.user.oneDimensionalMenu.filter(item => item.url === data.path)[0]
  newData.meta = hasData?.meta
  newData.name = hasData?.pathName
  // 跳转详情等2级页面时，tags显示名称，需要进行匹配寻找（根据传过来的按钮code，来匹配改按钮子集里type=2的页面名字）
  const btnCode = data.btnCode || data.query.btnCode
  if (btnCode) {
    const btnData = store.state.user.oneDimensionalMenu.filter(item => item.perms === btnCode)
    store.state.user.oneDimensionalMenu.forEach(item => {
      if (item.parentId === btnData[0].id) {
        if (item.type == 2) {
          newData.meta = { title: item.name }
        }
      }
    })
  }
  return newData
}
// wct通知
export function setDataForContainer(containerName, formOrigin, e) {
  const data = {
    type: "store",
    data: {
      fnType: "commit",
      nameSpace: "tagsView/BACK_TO_PAGE",
      fnData: { formOrigin: containerName, isBackWCT: true, url: e.detail.container.baseURI }
    }
  }
  microAppSetData(containerName, data)
}

// 确定子应用是否渲染完成，如果没有则进行手动渲染
export function checkSonAppRender(sysBelong) {
  return new Promise(resolve => {
    // 获取已经渲染过的应用
    const activeApps = getActiveApps()
    // 根据sysBelong，匹配获取当前跳转的页面对应的子应用name
    let appName = ""
    for (const sysBelongConfigKey in sysBelongConfig) {
      if (sysBelongConfig[sysBelongConfigKey] === sysBelong) {
        appName = sysBelongConfigKey
      }
    }
    // 判断当前要跳转的应用是否已被激活，如果没有激活，则手动渲染
    if (activeApps.indexOf(appName) < 0) {
      try {
        microApp
          .renderApp({
            name: appName,
            url: getFetchUrl(appName),
            container: ".el-container"
          })
          .then(result => {
            if (result) {
              console.log("渲染成功")
              resolve()
            } else {
              console.log("渲染失败")
            }
          })
      } catch (e) {
        console.log("checkSonAppRender方法错误")
        console.log(e)
        resolve()
      }
    } else {
      resolve()
    }
  })
}
const getFetchUrl = appNames => {
  for (const microappsKey in MICRO_APPS) {
    if (MICRO_APPS[microappsKey].name === appNames) {
      return hostMap(microappsKey)
    }
  }
}
